import InsuranceInPlaceEditor from './InsuranceInPlaceEditor';

export default InsuranceInPlaceEditor;
